import { isLiteralObject } from '.'
import { camelToSnake, snakeToCamel } from './text'

function keysTransformer (data, transformer) {
  if (isLiteralObject(data)) {
    return objTransformer(data, transformer)
  }

  if (Array.isArray(data)) {
    return arrayOfObjTransformer(data, transformer)
  }

  return data
}

function objTransformer (obj, transformer) {
  if (isLiteralObject(obj)) {
    const temp = {}

    Object.keys(obj).forEach((k) => {
      const value = obj[k]
      if (isLiteralObject(value)) {
        temp[transformer(k)] = objTransformer(value, transformer)
      } else if (Array.isArray(value)) {
        temp[transformer(k)] = arrayOfObjTransformer(value, transformer)
      } else {
        temp[transformer(k)] = value
      }
    })

    return temp
  }

  return obj
}

function arrayOfObjTransformer (data, transformer) {
  return data.map((item) => objTransformer(item, transformer))
}

function snakeKeysToCamel (data) {
  return keysTransformer(data, snakeToCamel)
}

function camelKeysToSnake (data) {
  return keysTransformer(data, camelToSnake)
}

export const textToCamelCase = (text) => {
  const camelCaseText = text.replace(/[-_](.)/g, function (_, char) {
    return char.toUpperCase()
  })

  const words = camelCaseText.split(/[^a-zA-Z]/).filter(word => word)

  const camelCaseResult = words.map((word, index) => {
    if (index === 0) {
      return word.toLowerCase()
    } else {
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    }
  }).join('')

  return camelCaseResult
}

function defaultFileInput () {
  return {
    blob: null,
    preview: null,
    name: null,
    type: null
  }
}

export { snakeKeysToCamel, camelKeysToSnake, defaultFileInput }
